import React, { useRef } from 'react';
import styles from '../../css/components/modals/modal.css';
import PropType from 'prop-types';
import PropTypes from 'prop-types';

function Modal({ 
	children,
	isShownAsOverlay = true,
	hasCloseButton = false,
	title = null,
	closeCallback = () => {},
	closeButtonId = 'n/a',
	shouldCloseByClickOutside = false,
}) {

	const modalRef = useRef();

	const onClickOutside = (e) => {
		if(!modalRef.current.contains(e.target) && shouldCloseByClickOutside) {
			closeCallback();
		}
	};

	return (
		<section
			className={`${styles.modal} ${styles.isShownAsOverlay}`}
			data-testid="modal">
			<div
				className={isShownAsOverlay ? `${styles.wrapper} ${styles.isShownAsOverlay}` : `${styles.wrapper}` } 
				onClick={(e) => onClickOutside(e)}
			>
				<div
					className={styles.inner}
					ref={modalRef}
				>
					<header
						className={styles.modalHeader}
						data-testid="modal-header">
						{title && <h1>{title}</h1>}
						{hasCloseButton &&(
							<button
								onClick={() => closeCallback()}
								id={closeButtonId}
							>
							</button>
						)}
					</header>
					<main
						className={styles.modalBody}
						data-testid="modal-body">
						<div className={styles.modalBodyWrapper}>
							{children}
						</div>
					</main>
				</div>
			</div>
		</section>
	);
}

export default Modal;
Modal.propTypes = {
	children: PropTypes.node.isRequired,
	isShownAsOverlay: PropType.bool.isRequired,
	title: PropTypes.string,
	hasCloseButton: PropTypes.bool,
	closeCallback: PropTypes.func,
	closeButtonId: PropType.string,
	shouldCloseByClickOutside: PropType.bool,
};